import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services';
import { useTranslation } from 'react-i18next';
import { usePageTitle, setDocumentTitle } from '../utils/translation';

interface OnboardingProps {
  onContinue: () => void;
}

const Onboarding: React.FC<OnboardingProps> = ({ onContinue }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const pageTitle = usePageTitle('pages.onboarding.title', 'Piika');

  useEffect(() => {
    // Set the document title
    setDocumentTitle(pageTitle);
    
    // Check if user is already logged in
    if (authService.isAuthenticated()) {
      navigate('/flowers');
      return;
    }
    
    // Set a timeout to automatically continue after 10 seconds
    const timer = setTimeout(() => {
      onContinue();
    }, 1000); // 10 seconds

    // Clean up the timer if the component unmounts
    return () => clearTimeout(timer);
  }, [onContinue, navigate, pageTitle]);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-white relative">
      {/* Blurred Circle */}
      <div
        className="absolute"
        style={{
          width: '150px',
          height: '150px',
          background: '#D9D9D9',
          filter: 'blur(12px)',
          borderRadius: '50%',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      ></div>

      {/* Text */}
      <h1 className="text-5xl font-bold text-gray-800 mb-4 relative">{t('pages.onboarding.brandName')}</h1>
    </div>
  );
};

// const styles = {
//   container: {
//     position: 'relative' as const,
//     width: '100%',
//     height: '100vh',
//     backgroundColor: '#fff',
//     overflow: 'hidden' as const,
//     display: 'flex',
//     flexDirection: 'column' as const,
//     alignItems: 'center',
//     justifyContent: 'space-between',
//   },
//   statusBar: {
//     width: '100%',
//     height: '54px',
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '0 20px',
//     alignItems: 'center',
//   },
//   timeContainer: {
//     flex: 1,
//     display: 'flex',
//     justifyContent: 'flex-start',
//   },
//   time: {
//     fontWeight: 'bold' as const,
//     fontSize: '16px',
//   },
//   iconsContainer: {
//     flex: 1,
//     display: 'flex',
//     justifyContent: 'flex-end',
//     gap: '8px',
//   },
//   squaresContainer: {
//     position: 'absolute' as const,
//     width: '100%',
//     height: '100%',
//     top: 0,
//     left: 0,
//   },
//   square: {
//     position: 'absolute' as const,
//     width: '162px',
//     height: '162px',
//     backgroundColor: '#FFF9E6',
//     borderRadius: '16px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 1,
//   },
//   icon: {
//     width: '60%',
//     height: '60%',
//     objectFit: 'contain' as const,
//   },
//   textContainer: {
//     width: '100%',
//     padding: '0 20px',
//     marginBottom: '60px',
//     textAlign: 'center' as const,
//     zIndex: 2,
//   },
//   brandName: {
//     fontSize: '30px',
//     fontWeight: 'bold' as const,
//     color: '#FCBE4D',
//     margin: '0 0 10px 0',
//   },
//   heading: {
//     fontSize: '32px',
//     fontWeight: 'bold' as const,
//     color: '#272727',
//     margin: 0,
//     lineHeight: 1.3,
//   },
//   button: {
//     width: 'calc(100% - 40px)',
//     maxWidth: '390px',
//     height: '65px',
//     backgroundColor: '#FCBE4D',
//     borderRadius: '50px',
//     border: 'none',
//     color: '#272727',
//     fontSize: '18px',
//     fontWeight: 'bold' as const,
//     cursor: 'pointer',
//     marginBottom: '40px',
//     zIndex: 2,
//   },
//   homeIndicator: {
//     width: '100%',
//     height: '21px',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     marginBottom: '8px',
//   },
//   homeIndicatorBar: {
//     width: '139px',
//     height: '5px',
//     backgroundColor: '#000',
//     borderRadius: '100px',
//   },
// };

export default Onboarding;
